module.exports = __webpack_public_path__ + "static/media/project1.646d138f.png";